import SessionDismissible, { NUDGE_IDS } from "../nudges/SessionDismissible";
import { useReferralOverlay } from "../../context/ReferralOverlayContext";
import "./FeedReferralPill.css";

export default function FeedReferralPill() {
  const { openReferral } = useReferralOverlay();

  return (
    <SessionDismissible id={NUDGE_IDS.HOME_REFERRAL_PILL} hideDismiss>
      {({ dismiss }) => (
        <div
          className="referral-pill"
          role="button"
          tabIndex={0}
          onClick={() => openReferral()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openReferral();
            }
          }}
        >
          <div className="rp-icon" aria-hidden>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <div className="rp-text">Know someone who&apos;d like this?</div>
          <div className="rp-cta">Invite</div>
          <button
            type="button"
            className="rp-dismiss"
            aria-label="Dismiss"
            onClick={(e) => {
              e.stopPropagation();
              dismiss();
            }}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      )}
    </SessionDismissible>
  );
}
